import React from "react";
import {connect} from "react-redux";
import {useFormikContext} from "formik";
import {DataNode} from "rc-tree/lib/interface";
import {RoleNameEnum} from "../../../../utils/types/common";
import {Button} from "@reside/ui";

import {usePointClickCareStatus} from "../../../../hooks/usePointClickCareStatus";
import {useHasPccActivityLog} from "../../../../hooks/useHasPccActivityLog";
import {useFacilitySettingsParams} from "../../hooks/useFacilitySettingsParams";
import {Facilities} from "../../../../models/types/AdmissionForm";
import {FacilityDeleteButton} from "../facility-delete-button";
import {ButtonLink} from "../../../../atoms/button-link";
import {AdminRoles} from "../../../../atoms/admin-roles";
import {select, AppState} from "../../../../store";
import {Space} from "../../../../atoms/space";
import {Header} from "./styles";

export type Props = Readonly<{
  facilities: Facilities;
  facilitiesTree: DataNode[];
}>;

const Renderer = ({facilities, facilitiesTree}: Props) => {
  const {facilityId} = useFacilitySettingsParams();

  const {isPccEnabled} = usePointClickCareStatus(facilities, facilityId);

  const facility = facilities?.find(facility => facility.id === facilityId);

  const formik = useFormikContext();

  const activeId = facility?.id || facilitiesTree[0]?.children[0]?.key;

  const hasPccActivityLog = useHasPccActivityLog(
    facilityId !== "_" ? facilityId : undefined,
    isPccEnabled,
  );

  return (
    <Header>
      {(isPccEnabled || hasPccActivityLog) && (
        <ButtonLink to={`/admin/facility/${activeId}/activity-log`}>
          Activity Log
        </ButtonLink>
      )}

      <Space style={{marginLeft: "auto"}}>
        {formik && (
          <>
            <AdminRoles roles={[RoleNameEnum.RESIDE_ADMIN]}>
              <FacilityDeleteButton />
            </AdminRoles>
            <ButtonLink to="/admin/dashboard">Cancel</ButtonLink>
            <Button
              color="success"
              testId="saveFacilitySettingsBtn"
              disabled={formik.isSubmitting || !formik.dirty}
              onClick={formik.submitForm}
            >
              {formik.isSubmitting ? "Saving..." : "Save"}
            </Button>
          </>
        )}
      </Space>
    </Header>
  );
};

export const FacilitySettingsHeader = connect((state: AppState) => ({
  facilities: select.adminSession.facilities(state),
  facilitiesTree: select.adminSession.facilitiesTree(state),
}))(Renderer);
